// This service is possibly not in use.
// That's not true.. 
// It is in use... 

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class AssetService {
  constructor(private http: HttpClient) {}
  updateEnergyEfficiencyRenewableRecoveryDetails(details: any) {
    // Replace with the actual API endpoint and return the HTTP request
    return this.http.post('/api/updateEnergyEfficiencyRenewableRecoveryDetails', details);
  }

}
